import { Injectable } from '@angular/core';

import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree
} from '@angular/router';

import {
  catchError,
  map,
  Observable,
  of
} from 'rxjs';

import {
  AuthService
} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard
  implements CanActivate, CanMatch {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree> {

    return this.check(
      state.url
    );
  }

  canMatch(
    route: Route,
    segments: UrlSegment[]
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree> {

    const requestedUrl =
      '/' +
      segments
        .map(segment =>
          segment.path
        )
        .join('/');

    return this.check(
      requestedUrl
    );
  }

  private check(
    returnUrl: string
  ):
    | UrlTree
    | Observable<boolean | UrlTree> {

    if (!this.auth.hasSession()) {
      this.auth.logout(false);

      return this.createLoginUrlTree(
        returnUrl
      );
    }

    return this.auth
      .ensureValidAccessToken()
      .pipe(
        map(() => true),

        catchError(() => {
          this.auth.logout(false);

          return of(
            this.createLoginUrlTree(
              returnUrl
            )
          );
        })
      );
  }

  private createLoginUrlTree(
    returnUrl: string
  ): UrlTree {
    return this.router.createUrlTree(
      ['/login'],
      {
        queryParams: {
          returnUrl
        }
      }
    );
  }
}